import { Accepts, Types } from "@citychallenge/common";
import { TransTokens } from "../../../i18n";
import { Inlet } from "../../reactive";
import { defineElement } from "../define-element";

export class ExplanationProps {
  @Inlet(Accepts.Image) public headerImage?: Types["Image"];

  @Inlet(Accepts.Boolean) public introduction?: Types["Boolean"];
  @Inlet(Accepts.Boolean) public time?: Types["Boolean"];
  @Inlet(Accepts.Boolean) public hints?: Types["Boolean"];
  @Inlet(Accepts.Boolean) public wrongAnswers?: Types["Boolean"];
  @Inlet(Accepts.Boolean) public skipping?: Types["Boolean"];
  @Inlet(Accepts.Boolean) public teams?: Types["Boolean"];
  @Inlet(Accepts.Number) public minPlayers?: Types["Number"];
  @Inlet(Accepts.Number) public maxPlayers?: Types["Number"];
  @Inlet(Accepts.Boolean) public playSafe?: Types["Boolean"];

  @Inlet(Accepts.MarkdownText) public lastWord?: Types["MarkdownText"];
}

export const ExplanationDefinition = defineElement(
  "explanation",
  ExplanationProps,
  {
    versionRequired: "0.23.0",
  }
);

export const explanationTokens = TransTokens.create({
  introduction: "Introduction",
  introductionDescription:
    "Before you start, here are some explanations to help you during your challenge.",

  time: "Time",
  timeDescription:
    "You can take as long as you want, but during some challenges you can earn a time bonus.",

  hints: "Hints",
  hintsDescription:
    "Are you stuck? Don't panic! You can ask for hints, each hint will cost you 20% of the points.",

  wrongAnswers: "Wrong answers",
  wrongAnswersDescription:
    "Giving a wrong answer will cost you 20% of the points.",

  skipping: "Skipping",
  skippingDescription:
    "If you're really stuck, you can skip to the next challenge in the menu.",

  teams: "Teams",
  teamsDescription:
    "Play with teams of {{minPlayers}} to max. {{maxPlayers}} people per device. Start 2 minutes after each other, this way your answers stay secret.",

  playSafe: "Play safe!",
  playSafeDescription:
    "You're playing outside in a busy city, please be aware of traffic and other people around you.",
});
